// src/config/launch.js
//
// Single source of truth for the founding-cohort offer terms.
//
// These values appear on the homepage and the /for-teachers landing page, and
// are quoted verbatim in cold outreach to teachers in the region. They change,
// and copy drifting out of sync between the two pages is exactly the kind of
// inconsistency this audience notices — so read them from here rather than
// hardcoding them in templates.
import { format, parseISO } from "date-fns";

export const LAUNCH = {
  // ISO date; render via formatLaunchDate so it reads as "31 August 2027".
  foundingOfferEndDate: "2027-08-31",
  foundingCohortSize: 10,
  // Commission taken on lessons booked through Crescendo once the founding
  // offer ends. Mirrors the platform fee in functions/index.js.
  commissionRate: 0.1,
  region: "east Kent",
};

/**
 * Format an ISO date for UK marketing copy, e.g. "2027-08-31" → "31 August 2027".
 * @param {string} isoDate
 * @returns {string}
 */
export const formatLaunchDate = (isoDate) =>
  format(parseISO(isoDate), "d MMMM yyyy");

/** The founding offer end date, ready to drop into copy. */
export const foundingOfferEndDateLabel = () =>
  formatLaunchDate(LAUNCH.foundingOfferEndDate);

/** The commission rate as a percentage string, e.g. "10%". */
export const commissionRateLabel = () =>
  `${Math.round(LAUNCH.commissionRate * 100)}%`;

export default LAUNCH;
